import {Component, ChangeDetectorRef, SimpleChanges, OnChanges } from '@angular/core';
import { KANBAN_TYPE_TASK, KanbanModel } from '../kanban.model';
import { ExpressionBuilderService } from '../../expression-builder/expression-builder.service';
import { AuthService } from 'src/app/core-api/services/auth/auth.service';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { AbstractWorkflowResultComponent } from '../../@core/abstract-workflow-result.component';

@Component({
    selector: 'abw-kanban-result',
    templateUrl: './kanban-result.component.html',
    styleUrls: ['./kanban-result.component.scss']
})
export class KanbanResultComponent extends AbstractWorkflowResultComponent<KanbanModel> implements OnChanges {
    datas = [];
    clients = [];
    banques = [];
    initializationError = false;
    KANBAN_TYPE_TASK = KANBAN_TYPE_TASK;

    constructor(
      protected workflowComponentsService: WorkflowComponentsService,
      protected expressionBuilderService: ExpressionBuilderService,
      protected authService: AuthService,
      protected cdf: ChangeDetectorRef,
    ) {
      super(workflowComponentsService, expressionBuilderService, authService, cdf);
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (!!changes.model?.currentValue) {
        try {
          this.initializationError = false;
  
          const valuePropName = this.model.additional.UIC_PARAMS.DATASOURCE.DATASOURCE_VALUE_FIELD;
          const displayPropName = this.model.additional.UIC_PARAMS.DATASOURCE.DATASOURCE_DISPLAY_FIELD;
          this.datas = this.model.additional.UIC_PARAMS.DATASOURCE.DATASOURCE_DATAS.map(d => {
            const id = d[valuePropName];
            return {
              ID: id,
              NAME: d[displayPropName],
              ITEMS: this.value[id] || []
            };
          });
  
          const valuePropNameClient = this.model.additional.UIC_PARAMS.DATASOURCE_CLIENTS.DATASOURCE_VALUE_FIELD;
          const displayPropNameClient = this.model.additional.UIC_PARAMS.DATASOURCE_CLIENTS.DATASOURCE_DISPLAY_FIELD;
          this.clients = this.model.additional.UIC_PARAMS.DATASOURCE_CLIENTS.DATASOURCE_DATAS.map(d => ({
            ID: d[valuePropNameClient],
            TEXT: d[displayPropNameClient]
          }));
  
          const valuePropNameBanque = this.model.additional.UIC_PARAMS.DATASOURCE_BANQUES.DATASOURCE_VALUE_FIELD;
          const displayPropNameBanque = this.model.additional.UIC_PARAMS.DATASOURCE_BANQUES.DATASOURCE_DISPLAY_FIELD;
          this.banques = this.model.additional.UIC_PARAMS.DATASOURCE_BANQUES.DATASOURCE_DATAS.map(d => ({
            ID: d[valuePropNameBanque],
            TEXT: d[displayPropNameBanque]
          }));

        } catch(err) {
          console.error(err);
          this.initializationError = true;
        }
      }
    }
}